// extracted by mini-css-extract-plugin
export default {"note":"styles_note__ICeJw"};